import { render, staticRenderFns } from "./index.html?vue&type=template&id=762d676e&scoped=true&external"
import script from "./AnPham.vue?vue&type=script&lang=js"
export * from "./AnPham.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762d676e",
  null
  
)

export default component.exports